import { useEffect, useRef } from 'react'
import { RouterProvider } from '@tanstack/react-router'
import { useAuth } from '@/contexts'
import { router } from './router'

/**
 * Wraps {@link RouterProvider} and re-runs the route guards (beforeLoad) when the authenticated
 * identity or role changes. The guards read a session cached for the page load
 * (authService.ensureSession), so without this a SOFT auth transition that isn't a full navigation
 * — chiefly a connection-lost retry that recovers the session — would leave their access scoping
 * un-applied until the next navigation. Login and logout are full navigations that reload the cache
 * anyway; this covers the in-place case. The initial mount is skipped (the guards already ran with
 * the same session).
 */
export function RouterWithAuth() {
  const { currentUser, isAuthenticated } = useAuth()
  const didMount = useRef(false)
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true
      return
    }
    router.invalidate()
  }, [currentUser?.uuid, currentUser?.role, isAuthenticated])
  return <RouterProvider router={router} />
}
